import React, { Children, lazy } from 'react';
import { motion } from 'framer-motion';
export function BonosSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="w-full bg-gradient-to-b from-[#E6F7FF] to-[#FFFFFF] py-10 px-4 md:py-16 overflow-hidden" data-id="element-24">
      <motion.div className="max-w-md md:max-w-2xl mx-auto text-center" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      amount: 0.15
    }} data-id="element-25">
        {/* Header */}
        <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-black text-red-600 mb-2" data-id="element-26">
          ¡TE REGALO!
        </motion.h2>
        <motion.p variants={itemVariants} className="text-lg md:text-xl font-semibold text-gray-800" data-id="element-27">
          Querido Papá y Querida Mamá
        </motion.p>
        <motion.p variants={itemVariants} className="text-base md:text-lg font-semibold text-gray-800 mt-2 mb-6" data-id="element-28">
          SI COMPLETAS LA COMPRA EN LOS PRÓXIMOS
          <span className="text-blue-600 font-extrabold" data-id="element-29"> 10 MINUTOS</span>, TE
          LLEVARÁS ESTOS DOS REGALOS
        </motion.p>

        {/* BONO #1 */}
        <motion.div variants={itemVariants} className="bg-yellow-100 rounded-2xl shadow-lg p-6 md:p-8 text-center mt-8" data-id="element-30">
          <h3 className="text-xl md:text-2xl font-black text-yellow-700 mb-2" data-id="element-31">
            BONO #1: LIBRO PARA COLOREAR
          </h3>
          <p className="text-base md:text-lg text-gray-800 leading-snug" data-id="element-32">
            Estimula la creatividad y motricidad fina de tu peque con páginas
            para colorear que enseñan mientras juegan.
          </p>
          <p className="mt-3" data-id="element-33">
            <span className="line-through text-red-500 font-semibold" data-id="element-34">
              Precio: ~$14.200 ARS~
            </span>
            <br data-id="element-35" />
            <span className="text-green-600 font-bold text-lg" data-id="element-36">
              Hoy: Gratis ✅
            </span>
          </p>
          <img src="https://cdn.magicpatterns.com/uploads/7VsNLtqvfJxSUhMog3n6Gh/ChatGPT-Image-30-abr-2025-11_30_22-a.m.-1-1.png" alt="Libro para colorear" className="mt-4 mx-auto rounded-xl w-full max-h-80 object-cover" loading="lazy" data-id="element-37" />
        </motion.div>

        {/* BONO #2 */}
        <motion.div variants={itemVariants} className="bg-purple-100 rounded-2xl shadow-lg p-6 md:p-8 text-center mt-6" data-id="element-38">
          <h3 className="text-xl md:text-2xl font-black text-purple-700 mb-2" data-id="element-39">
            BONO #2: MIS HÁBITOS Y RUTINAS
          </h3>
          <p className="text-base md:text-lg text-gray-800 leading-snug" data-id="element-40">
            Enseña buenos hábitos y rutinas desde temprana edad con actividades
            diseñadas para que tu niño o niña aprenda mientras se divierte.
          </p>
          <p className="mt-3" data-id="element-41">
            <span className="line-through text-red-500 font-semibold" data-id="element-42">
              Precio: ~$11.400 ARS~
            </span>
            <br data-id="element-43" />
            <span className="text-green-600 font-bold text-lg" data-id="element-44">
              Hoy: Gratis ✅
            </span>
          </p>
          <img src="https://cdn.magicpatterns.com/uploads/7yPsJUSaQg32YYnsoLN6q7/ChatGPT-Image-30-abr-2025-11_31_50-a.m.-1-1.png" alt="Mis hábitos y rutinas" className="mt-4 mx-auto rounded-xl w-full max-h-80 object-cover" loading="lazy" data-id="element-45" />
        </motion.div>
      </motion.div>
    </section>;
}